// Make product rating stars clickable -> smooth-scroll to the Judge.me reviews
// widget at the bottom of the page (falls back to our own reviews section).
(function () {
  var RATING = '.mm-sw__rate, .mm-bch__rate, .mm-mch__rate, .mm-bb__rate, .mm-hero__rating';

  function findReviews() {
    return document.querySelector(
      '.jdgm-rev-widg, .jdgm-review-widget, [id^="judgeme_product_reviews"], [id*="judge_me_reviews"]'
    ) || document.querySelector(
      '[data-section="reviews"], .shopify-section--sw-reviews, .shopify-section--masterclass-reviews, .shopify-section--bc-reviews, #reviews'
    );
  }

  function scrollToReviews() {
    var t = findReviews();
    if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.querySelectorAll(RATING).forEach(function (el) {
    el.classList.add('mm-rate-link');
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-label', 'Read the reviews');
    el.addEventListener('click', scrollToReviews);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scrollToReviews(); }
    });
  });
})();
